<template>
  <div ref="boudingBox" class="bouding-box">
    <div name="switch" class="switch" :style="`transform: translateX(${- center}px);`">
      <div class="switch-tracker" :style="`width: ${trackerWidth}px; transform: translateX(${trackerPostition}px);`"></div>

      <button v-for="(tab, index) in tabs" :key="index"
        class="switch-button" 
        :style="`width: ${buttonWidth(tab)}px; font-size: ${fontsize}px;`"
        :class="selectedBerging === tab.id ? 'switch-button-active' : ''" 
        @click="$emit('change', tab.id)"
      >
      <mdicon class="switch-button-icon" :name="tab.icon" size="30" />
        {{ tab.name }}
      </button>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: "tab-selector",

    props: {
      tabs: Array,
      selectedBerging: String,
    },

    data () {
      return {
        //position: 0,
        maxWidth: 0,
        fontsize: 14,
        resizeInterval: null
      }
    },

    methods: {
      buttonWidth(text) {
        let textLength = text.name.length * 8
        let buttonPadding = 10
        let icon = 25
        
        let totalWidth = 0
        for(let i=0; i<this.tabs.length; i++) {
          let text = this.tabs[i].name
          let textLength = text.length * 8
          let buttonPadding = 10
          let icon = 25
          totalWidth += (textLength + buttonPadding + icon)
        }
        return (this.maxWidth-buttonPadding*this.tabs.length+1) / (totalWidth / (textLength + buttonPadding + icon))
      },

      handleResize () {
        if (this.$refs.boudingBox) {
          this.maxWidth = this.$refs.boudingBox.clientWidth-10
        }
        let amountOfLetters = 0
        for(let i=0; i<this.tabs.length; i++) {
          amountOfLetters += this.tabs[i].name.length
        }
        this.fontsize = this.maxWidth / amountOfLetters * 0.8
      }
    },

    computed: {

      trackerWidth () {
        // console.log(this.tabs)
        // console.log(this.accuratePosition)
        let text = this.tabs[this.accuratePosition] ? this.tabs[this.accuratePosition].name : 'placeholder'
        let textLength = text.length * 8 
        let buttonPadding = 10
        let icon = 25

        let totalWidth = 0
        for(let i=0; i<this.tabs.length; i++) {
          let text = this.tabs[i].name
          let textLength = text.length * 8
          let buttonPadding = 10
          let icon = 25
          totalWidth += (textLength + buttonPadding + icon)
        }
        return (this.maxWidth-buttonPadding*this.tabs.length+1) / (totalWidth / (textLength + buttonPadding + icon))
      },

      trackerPostition () {
        if (this.accuratePosition > 0) {
          let padding = (this.accuratePosition * 10)
          let buttons = 0 

          let totalWidth = 0
          for(let i=0; i<this.tabs.length; i++) {
            let text = this.tabs[i].name
            let textLength = text.length * 8
            let buttonPadding = 10
            let icon = 25
            totalWidth += (textLength + buttonPadding + icon)
          }

          for (let i = 0; i < this.accuratePosition; i++) {
            let text = this.tabs[i].name
            let textLength = text.length * 8
            let buttonPadding = 10
            let icon = 25
            buttons += ((this.maxWidth-buttonPadding*this.tabs.length+1) / (totalWidth / (textLength + buttonPadding+ icon)))
          }
          return padding + buttons
        } else {
          return 0
        }
      },

      center () {
          
        return 0
      },

      accuratePosition () {
        let currentPosition
        for(let i=0; i<this.tabs.length; i++) {
          if(this.selectedBerging === this.tabs[i].id) {
            currentPosition = i
          }
        }
        // console.log(currentPosition)
        return currentPosition !== undefined ? currentPosition : 0
        //currentPath.substring(currentPath.lastIndexOf('/'), currentPath.length) === tab.route

      },


      ...mapGetters({
        currentPath: 'getCurrentPath',
      })

      // center () {
      //   console.log(this.$refs["bouding-box"])

      //   if (this.boudingBox) {
      //     let maxWidth = this.$refs["bouding-box"].clientWidth

      //     console.log(maxWidth)

      //     if (this.totalWidth > maxWidth) {
      //       let maxRight = this.totalWidth - maxWidth
            
      //       console.log(maxRight)

      //       if (this.trackerPostition > maxRight) {
      //         return maxRight
      //       } else {

      //         return this.trackerPostition
      //       }
      //     } else {
      //       return 0
      //     }
      //   } else {
      //     return 0
      //   }
      // }
    },

    watch: {
      selectedBerging() {
        this.handleResize()
      }
    },

    created () {
      window.addEventListener('resize', this.handleResize);
    },

    mounted () {
      this.handleResize()
      this.resizeInterval = setInterval(() => {
        this.handleResize()
      }, 1000/60)
      setTimeout(() => {
        clearInterval(this.resizeInterval)
      }, 1000)
    },

    unmounted () {
      window.removeEventListener('resize', this.handleResize);
      clearInterval(this.resizeInterval)
    },

    /*watch: {
      currentPath(to) {
        for(let i=0; i<this.tabs.length; i++) {
          if(to.substring(to.lastIndexOf('/'), to.length) === this.tabs[i].route) {
            this.position = i
          }
          console.log(this.tabs)
          console.log(to)
        }
      }
    }*/

    // watch: {
    //   $router () {
    //     this.handleResize()
    //   }
    // }
  }
</script>

<style lang="scss" scoped>

.bouding-box {
  display: flex;
  background: $c-background-1;
  border-radius: $radius-m;
  overflow: hidden;
  width: 100%;
  height: 80px;
  padding: 8px;
  box-sizing: border-box;
}

@media (max-width: 999px) {
  .bouding-box {
    max-width: 97%;
    width: 97%;
  }
}

.switch {
  display: flex;
  gap: 8px;
  position: relative;
  z-index: 10;
  transition: transform 200ms ease;

  &-button {
    background-color: transparent;
    border: none;
    display: flex;
    gap: 5px;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    color: $c-secondary-text;
    z-index: 12;
    margin: 0px;
    height: 100%;
    border-radius: 6px;
    transition: color 200ms ease;
    text-decoration: none;
    font-weight: 600;
    transition: background-color 100ms ease;
    font-family: 'Oswald', sans-serif;
    text-transform: uppercase;
    font-size: 19px;
    color: $c-primary;

    &:hover {
      background-color: $c-background-1-hover;
      cursor: pointer;
    }

    &-active {
      color: $c-secondary-bright;//$c-secondary;
      background-color: $c-primary;

      &:hover {
        background-color: transparent;
        cursor: default;
      }
    }
  }

  &-tracker {
    content: "";
    position: absolute;
    background-color: $c-primary;
    height: 100%;
    z-index: 11;
    border-radius: 6px;
    transition: transform 200ms ease, width 100ms ease;
  }
}


</style>